import { submitNewTaskItemFileFlow } from './submitNewTaskItemFileFlow'
import { submitNewLabelF } from './submitNewLabelF'

export const submitNewFlows = [submitNewLabelF, submitNewTaskItemFileFlow]
